import _merge from 'lodash/merge';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { getFont, FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { PRIMARY, DEFAULT_MODE, makeThemeColor, QUINARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../../utils/style';
import { identity } from '../../../../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const INCENTIVE_PADDING = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const BORDER_RADIUS = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(QUINARY),
};

export const makeBasicTextStyle = ({ font, colorMode = DEFAULT_MODE }) => ({
  color: colors.text[colorMode],
  text: {
    ...font,
    verticalAlign: 'middle',
    wordWrap: false,
  },
});

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const h = HEIGHT[screenSize];
  const font = getFont(FONT.BOSTON_3, screenSize, TITLE_FONT_TYPE);

  return _merge({
    h,
    Background: {
      h,
      color: colors.background[colorMode],
      shader: {
        radius: BORDER_RADIUS[screenSize],
      },
      w: identity,
    },
    Label: {
      y: Math.round((h - font.lineHeight) / 2),
      ...makeBasicTextStyle({
        font: getFont(FONT.BOSTON_3, screenSize, TITLE_FONT_TYPE),
        colorMode,
      }),
    },
  });
};
